import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
import Select from 'react-select';
import services from 'API/services';
import { ROOM_CATEGORY } from 'constant/constants';
import { toast } from 'react-toastify';
import axios from 'axios';
import { mainUrl } from 'API/client/api';
import { useDispatch } from 'react-redux';
import { createPropertyLogs } from 'store/slices/PropertyData';


const ModalBulkUpdate = ({ show, hide, timeZone, rooms, refreshData, handleQuickSoldOut, selectedDates, setSelectedDates, hotelInfo, allowHourly, userDetail }) => {
  const dispatch = useDispatch();
  const [stopSell, setStopSell] = useState(false)
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [slotStatus, setSlotStatus] = useState({
    threeHrs: true,
    sixHrs: true,
    nineHrs: true,
    fullDay: true
  });
  const [slotTiming, setSlotTiming] = useState({
    threeHrs: { checkIn: "", checkOut: "" },
    sixHrs: { checkIn: "", checkOut: "" },
    nineHrs: { checkIn: "", checkOut: "" },
  });
  const [slotPrice, setSlotPrice] = useState({
    threeHrs: "",
    sixHrs: "",
    nineHrs: "",
    fullDay: ""
  });
  const [error, setError] = useState('')
  const [roomInfo, setRoomInfo] = useState([]);

  const handleClose = () => { hide(false); setStopSell(false) };

  const allOption = { label: "All", value: "*", categoryId: 0 };

  const categories = rooms.map((item) => {
    return {
      label: ROOM_CATEGORY?.[item?.categoryId].toLowerCase().replace(/\b\w/g, c => c.toUpperCase()),
      value: item?.id,
      categoryId: item?.categoryId
    }
  })

  const selectOptions = [allOption, ...categories];

  const [selected, setSelected] = useState(categories?.map(c => c.value));

  const [logData, setLogData] = useState({
    fromDate: "",
    toDate: "",
    categories: [],
    slotPrice: {},
    slotStatus: {},
    slotTime: {}
  });

  function generatePayloads(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    const payloads = [];
    let currentDate = new Date(startDate);
    while (currentDate.getTime() <= endDate.getTime()) {
      const formattedDate = currentDate.toISOString().split('T')[0];
      payloads.push({
        date: formattedDate,
        soldOut: true
      });
      currentDate.setDate(currentDate.getDate() + 1); // move to next day
    }
    return payloads;
  }

  const handleChange = (options) => {
    if (!options) {
      setSelected([]);
      return;
    }
    if (options.find(opt => opt.value == "*")) { setSelected(categories.map(c => c.value)); }
    else { setSelected(options.map(opt => opt.value)); }
  };

  useEffect(() => { if (selected.length > 0) { setError(''); } }, [selected])

  const [cateForThird, setCateForThird] = useState([])

  useEffect(() => {
    const result = categories
      .filter(item => selected.includes(item.value))
      .map(item => item.categoryId);
    setCateForThird(result)
  }, [selected])

  const existSoldOutDates = rooms?.map((item) => {
    let parsedStatus = [];
    if (typeof item.status == "string" && item.status.trim().startsWith("[")) {
      try { parsedStatus = JSON.parse(item.status); }
      catch (error) { console.error("Invalid JSON in item.status:", item.status); }
    }
    const soldOutDates = parsedStatus.filter((data) => data.soldOut === true);
    return { [item.id]: soldOutDates };
  });

  const handleBulkUpdate = async () => {
    if (selected.length == 0) {
      setError('Please select a category');
      return
    }
    const getDatesBetween = (start, end) => {
      const dates = [];
      const dates1 = [];
      const curr = moment(start).startOf('day');
      const last = moment(end).startOf('day');
      while (curr <= last) {
        dates.push(curr.clone()); // pure moment objects
        dates1.push({
          date: curr.format("YYYY-MM-DD"), // formatted string
          soldOut: true,
        });
        curr.add(1, 'day');
      }
      return { dates, dates1 };
    };
    const { dates, dates1 } = getDatesBetween(startDate, endDate);
    // const allDates = getDatesBetween(startDate, endDate);
    let payload
    payload = {
      fullDayStatus: {},
      threeHrStatus: {},
      sixHrStatus: {},
      nineHrStatus: {},
      offerPrice: {},
      threeHrOfferPrice: {},
      sixHrOfferPrice: {},
      nineHrOfferPrice: {},
      threeHrCheckIn: {},
      sixHrCheckIn: {},
      nineHrCheckIn: {},
      // status: stopSell ? dates1 : {},
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    }
    if (stopSell == false) {
      dates.forEach((date) => {
        const dateStr = date?.format('YYYY-MM-DD');
        // Availability
        payload.threeHrStatus[dateStr] = [
          { slot: "FullDay", status: slotStatus.fullDay ? "Available" : "Sold-Out" },
          { slot: "3Hrs", status: slotStatus.threeHrs ? "Available" : "Sold-Out" },
          { slot: "6Hrs", status: slotStatus.sixHrs ? "Available" : "Sold-Out" },
          { slot: "9Hrs", status: slotStatus.nineHrs ? "Available" : "Sold-Out" },
        ];
        payload.sixHrStatus[dateStr] = [
          { slot: "FullDay", status: slotStatus.fullDay ? "Available" : "Sold-Out" },
          { slot: "3Hrs", status: slotStatus.threeHrs ? "Available" : "Sold-Out" },
          { slot: "6Hrs", status: slotStatus.sixHrs ? "Available" : "Sold-Out" },
          { slot: "9Hrs", status: slotStatus.nineHrs ? "Available" : "Sold-Out" },
        ];
        payload.nineHrStatus[dateStr] = [
          { slot: "FullDay", status: slotStatus.fullDay ? "Available" : "Sold-Out" },
          { slot: "3Hrs", status: slotStatus.threeHrs ? "Available" : "Sold-Out" },
          { slot: "6Hrs", status: slotStatus.sixHrs ? "Available" : "Sold-Out" },
          { slot: "9Hrs", status: slotStatus.nineHrs ? "Available" : "Sold-Out" },
        ];
        payload.fullDayStatus[dateStr] = [
          { slot: "FullDay", status: slotStatus.fullDay ? "Available" : "Sold-Out" },
          { slot: "3Hrs", status: slotStatus.threeHrs ? "Available" : "Sold-Out" },
          { slot: "6Hrs", status: slotStatus.sixHrs ? "Available" : "Sold-Out" },
          { slot: "9Hrs", status: slotStatus.nineHrs ? "Available" : "Sold-Out" },
        ];
        // CheckIn / CheckOut times
        payload.threeHrCheckIn[dateStr] = [
          { slot: "3Hrs", checkIn: slotTiming.threeHrs.checkIn, checkOut: slotTiming.threeHrs.checkOut },
          { slot: "6Hrs", checkIn: slotTiming.sixHrs.checkIn, checkOut: slotTiming.sixHrs.checkOut },
          { slot: "9Hrs", checkIn: slotTiming.nineHrs.checkIn, checkOut: slotTiming.nineHrs.checkOut },
        ];
        payload.sixHrCheckIn[dateStr] = [
          { slot: "3Hrs", checkIn: slotTiming.threeHrs.checkIn, checkOut: slotTiming.threeHrs.checkOut },
          { slot: "6Hrs", checkIn: slotTiming.sixHrs.checkIn, checkOut: slotTiming.sixHrs.checkOut },
          { slot: "9Hrs", checkIn: slotTiming.nineHrs.checkIn, checkOut: slotTiming.nineHrs.checkOut },
        ];
        payload.nineHrCheckIn[dateStr] = [
          { slot: "3Hrs", checkIn: slotTiming.threeHrs.checkIn, checkOut: slotTiming.threeHrs.checkOut },
          { slot: "6Hrs", checkIn: slotTiming.sixHrs.checkIn, checkOut: slotTiming.sixHrs.checkOut },
          { slot: "9Hrs", checkIn: slotTiming.nineHrs.checkIn, checkOut: slotTiming.nineHrs.checkOut },
        ];
        payload.offerPrice[dateStr] = [
          { slot: "FullDay", price: slotPrice.fullDay },
          { slot: "3Hrs", price: slotPrice.threeHrs },
          { slot: "6Hrs", price: slotPrice.sixHrs },
          { slot: "9Hrs", price: slotPrice.nineHrs },
        ];
        payload.threeHrOfferPrice[dateStr] = [
          { slot: "FullDay", price: slotPrice.fullDay },
          { slot: "3Hrs", price: slotPrice.threeHrs },
          { slot: "6Hrs", price: slotPrice.sixHrs },
          { slot: "9Hrs", price: slotPrice.nineHrs },
        ];
        payload.sixHrOfferPrice[dateStr] = [
          { slot: "FullDay", price: slotPrice.fullDay },
          { slot: "3Hrs", price: slotPrice.threeHrs },
          { slot: "6Hrs", price: slotPrice.sixHrs },
          { slot: "9Hrs", price: slotPrice.nineHrs },
        ];
        payload.nineHrOfferPrice[dateStr] = [
          { slot: "FullDay", price: slotPrice.fullDay },
          { slot: "3Hrs", price: slotPrice.threeHrs },
          { slot: "6Hrs", price: slotPrice.sixHrs },
          { slot: "9Hrs", price: slotPrice.nineHrs },
        ];
      });
    }
    try {
      const res = await Promise.all(
        selected?.map(id => {
          const matched = existSoldOutDates?.find(obj => Number(Object.keys(obj)[0]) === id);
          const items = matched ? matched[Object.keys(matched)[0]] : null;
          const merged = [
            ...items,
            ...dates1?.filter(
              d1 => !items?.some(d2 => d2.date === d1.date)
            )
          ];
          payload.status = stopSell ? merged : {};
          return services.property.updateRoomPrice(payload, id)
        })
      );
      if (res[0]?.data?.status == true) {
        const params = {
          action: `Bulk Update ${stopSell ? '- Stop Sell' : ''}`,
          actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
          propertyId: userDetail?.propertyId
        }
        params.operation = stopSell ? JSON.stringify({ fromDate: startDate, toDate: endDate, categoryIds: selected }) : JSON.stringify(logData)
        dispatch(createPropertyLogs(params))
        toast.success("Room data updated successfully");
        refreshData();
        handleClose();
        setStopSell(false)
        setSelected([])
        setStartDate(new Date())
        setEndDate(new Date())
        setSlotPrice({
          threeHrs: "",
          sixHrs: "",
          nineHrs: "",
          fullDay: ""
        })

        cateForThird?.forEach((cateId) => {
          const RoomsCategoryId = cateId == 1 ? "STANDARD DOUBLE BED"
            : cateId == 2 ? "DELUXE ROOM"
              : cateId == 3 ? "SUITE ROOM"
                : cateId == 5 ? "STANDARD SINGLE BED"
                  : cateId == 6 ? "STANDARD TWIN BED"
                    : cateId == 7 ? "DELUXE TWIN BED"
                      : cateId == 9 ? "FAMILY ROOM"
                        : cateId == 10 ? "PREMIUM ROOM"
                          : "STANDARD DOUBLE BED";
          const dataToBeSend = roomInfo?.find((item) => item?.RoomType?.toUpperCase() == RoomsCategoryId?.toUpperCase());
          if (dataToBeSend && stopSell) { bulkUpdate(dataToBeSend?.RatePlanID) }
          if (dataToBeSend && slotPrice?.fullDay) { updateLinearRate(dataToBeSend?.RoomTypeID, dataToBeSend?.RateTypeID) }
        })
      }
    }
    catch (err) { console.log(err) }
  };

  useEffect(() => {
    const filteredSlotPrice = Object.fromEntries(
      Object.entries(slotPrice).filter(([_, value]) => value !== "" && value != null)
    );

    const filteredSlotStatus = Object.fromEntries(
      Object.entries(slotStatus)
        .filter(([_, value]) => value !== "" && value != null)
        .map(([key, value]) => [key, value ? "Available" : "Sold Out"])
    );
    const filteredSlotTime = Object.fromEntries(
      Object.entries(slotTiming).filter(
        ([_, value]) => value.checkIn || value.checkOut
      )
    );
    setLogData(prev => {
      const newSlotPrice = { ...prev.slotPrice, ...filteredSlotPrice };
      Object.keys(prev.slotPrice).forEach(key => {
        if (!slotPrice[key] || slotPrice[key] === "") {
          delete newSlotPrice[key];
        }
      });
      const newSlotStatus = { ...prev.slotStatus, ...filteredSlotStatus };
      Object.keys(prev.slotStatus).forEach(key => {
        if (slotStatus[key] === "" || slotStatus[key] == null) {
          delete newSlotStatus[key];
        }
      });
      const newSlotTime = { ...prev.slotTime, ...filteredSlotTime };
      Object.keys(prev.slotTime).forEach(key => {
        const value = slotTiming[key];
        if (!value || (!value.checkIn && !value.checkOut)) {
          delete newSlotTime[key];
        }
      });
      return {
        ...prev,
        fromDate: startDate || prev.fromDate,
        toDate: endDate || prev.toDate,
        categories: selected?.length ? selected : prev.categories,
        slotPrice: newSlotPrice,
        slotStatus: newSlotStatus,
        slotTime: newSlotTime
      };
    });
  }, [startDate, endDate, selected, slotPrice, slotStatus, slotTiming]);

  const fetchRoomInformation = async () => {
    const payload = {
      RES_Request: {
        Request_Type: "RoomInfo",
        NeedPhysicalRooms: 1,
        Authentication: {
          HotelCode: hotelInfo?.locationId,
          AuthCode: hotelInfo?.authCode
        }
      }
    }
    try {
      const res = await axios.post(`${mainUrl}api/proxy`, payload);
      if (res) { setRoomInfo(res.data.data.RoomInfo.RatePlans.RatePlan) }
    }
    catch (err) { console.log('Error:', err.response ? err.response.data : err.message) }
  }

  useEffect(() => { if (hotelInfo) { fetchRoomInformation() } }, [hotelInfo])

  const bulkUpdate = async (RoomTypeID) => {
    let payload = {
      RES_Request: {
        Request_Type: "UpdateStopSell",
        Authentication: {
          HotelCode: hotelInfo?.locationId,
          AuthCode: hotelInfo?.authCode
        },
        RatePlan: [
          {
            RatePlanID: RoomTypeID,
            FromDate: moment(startDate).format('YYYY-MM-DD'),
            ToDate: moment(endDate).format('YYYY-MM-DD'),
            StopSell: "1"
          }
        ]
      }
    }
    const res = await axios.post(`${mainUrl}api/stop-sell`, payload);
  }

  const updateLinearRate = async (RoomTypeID, RateTypeID) => {
    let payload = {
      RES_Request: {
        Request_Type: "UpdateRoomRates",
        Authentication: {
          HotelCode: hotelInfo?.locationId,
          AuthCode: hotelInfo?.authCode
        },
        RateType: [
          {
            RoomTypeID: RoomTypeID,
            RateTypeID: RateTypeID,
            FromDate: moment(startDate).format('YYYY-MM-DD'),
            ToDate: moment(endDate).format('YYYY-MM-DD'),
            RoomRate: {
              Base: slotPrice?.fullDay
            }
          }
        ]
      }
    }
    const res = await axios.post(`${mainUrl}api/update-room-rate`, payload);
  }

  const cateForSlot = selectOptions?.find((item) => selected.includes(item.value))?.categoryId

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header>
        <Modal.Title>Bulk Update</Modal.Title>
      </Modal.Header>
      <Modal.Body className='bulk-update-modal'>
        <div className='p-4 pb-0'>
          <div className='row'>
            <div className='col-lg-5'>
              <div className='form-group'>
                <label className='field-label'>Start Date<span className='text-danger'>*</span></label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  className='field-control'
                  dateFormat="dd-MM-yyyy"
                  minDate={new Date()}
                />
              </div>
            </div>
            <div className='col-lg-5'>
              <div className='form-group'>
                <label className='field-label'>End Date<span className='text-danger'>*</span></label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  className='field-control'
                  dateFormat="dd-MM-yyyy"
                  minDate={startDate}
                />
              </div>
            </div>
            <div className='col-lg-2 stop-sell-col'>
              <div className='form-group text-right mb-0'>
                <label className='field-label' style={{ opacity: '0' }}>Stop Sell</label>
                <div class="btn_check mt-2">
                  <input type="checkbox" id="check" checked={stopSell}
                    onChange={(e) => setStopSell(e.target.checked)} />
                  <label class="btn btn-default" for="check">
                    <i class="fa fa-square-o"></i> Stop Sell
                  </label>
                </div>
              </div>
            </div>

            <div className='col-lg-12'>
              <div className='form-group'>
                <label className='field-label'>Select Category<span className='text-danger'>*</span></label>
                <Select
                  options={selectOptions}
                  onChange={handleChange}
                  value={selectOptions?.filter(opt => selected.includes(opt.value))}
                  isMulti
                  placeholder="Select Category"
                />
                {error && <p className='text-danger fs-8 text-left pt-2'>{error}</p>}
              </div>
            </div>
            {
              !stopSell && (
                <>
                  <div className='col-lg-12'>
                    <div className='bulk-update'>
                      <div className='card'>
                        <div className='heading'>
                          Rate (GST Exclusive)
                        </div>
                        <div className='head'>
                          {
                            allowHourly && cateForSlot == 1 ? (
                              <>
                                <div className='column'>
                                  <h6>3 Hrs</h6>
                                </div>
                                <div className='column'>
                                  <h6>6 Hrs</h6>
                                </div>
                                <div className='column'>
                                  <h6>9 Hrs</h6>
                                </div>
                              </>
                            ) : ''
                          }
                          <div className='column'>
                            <h6>FullDay</h6>
                          </div>
                        </div>
                        <div className='body'>
                          {
                            allowHourly && cateForSlot == 1 ? (
                              <>
                                <div className='column'>
                                  <h6>3 Hrs</h6>
                                  <input
                                    type="text"
                                    className="form-item fixed-width"
                                    placeholder="Price"
                                    value={slotPrice.threeHrs}
                                    onChange={(e) => setSlotPrice(prev => ({ ...prev, threeHrs: e.target.value }))}
                                  />
                                  <div className='pt-2'>
                                    <label className={`switch ${slotStatus.threeHrs ? "active" : ""}`}>
                                      <input
                                        type="checkbox"
                                        checked={slotStatus.threeHrs}
                                        onChange={() => setSlotStatus(prev => ({ ...prev, threeHrs: !prev.threeHrs }))}
                                      />
                                      <span className="text">{slotStatus.threeHrs ? "Available" : "Sold-Out"}</span>
                                    </label>
                                  </div>
                                </div>
                                <div className='column'>
                                  <h6>6 Hrs</h6>
                                  <input
                                    type="text"
                                    className="form-item fixed-width"
                                    placeholder="Price"
                                    value={slotPrice.sixHrs}
                                    onChange={(e) => setSlotPrice(prev => ({ ...prev, sixHrs: e.target.value }))}
                                  />
                                  <div className='pt-2'>
                                    <label className={`switch ${slotStatus.sixHrs ? "active" : ""}`}>
                                      <input
                                        type="checkbox"
                                        checked={slotStatus.sixHrs}
                                        onChange={() => setSlotStatus(prev => ({ ...prev, sixHrs: !prev.sixHrs }))}
                                      />
                                      <span className="text">{slotStatus.sixHrs ? "Available" : "Sold-Out"}</span>
                                    </label>
                                  </div>
                                </div>
                                <div className='column'>
                                  <h6>9 Hrs</h6>
                                  <input
                                    type="text"
                                    className="form-item fixed-width"
                                    placeholder="Price"
                                    value={slotPrice.nineHrs}
                                    onChange={(e) => setSlotPrice(prev => ({ ...prev, nineHrs: e.target.value }))}
                                  />
                                  <div className='pt-2'>
                                    <label className={`switch ${slotStatus.nineHrs ? "active" : ""}`}>
                                      <input
                                        type="checkbox"
                                        checked={slotStatus.nineHrs}
                                        onChange={() => setSlotStatus(prev => ({ ...prev, nineHrs: !prev.nineHrs }))}
                                      />
                                      <span className="text">{slotStatus.nineHrs ? "Available" : "Sold-Out"}</span>
                                    </label>
                                  </div>
                                </div>
                              </>
                            ) : ''
                          }
                          <div className='column'>
                            <h6>FullDay</h6>
                            <input
                              type="text"
                              className="form-item fixed-width"
                              placeholder="Price"
                              value={slotPrice.fullDay}
                              onChange={(e) => setSlotPrice(prev => ({ ...prev, fullDay: e.target.value }))}
                            />
                            <div className='pt-2'>
                              <label className={`switch ${slotStatus.fullDay ? "active" : ""}`}>
                                <input
                                  type="checkbox"
                                  checked={slotStatus.fullDay}
                                  onChange={() => setSlotStatus(prev => ({ ...prev, fullDay: !prev.fullDay }))}
                                />
                                <span className="text">{slotStatus.fullDay ? "Available" : "Sold-Out"}</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {
                        allowHourly && cateForSlot == 1 ? (
                          <div className='card'>
                            <div className='heading '>
                              Manage Timing (First Check in - Last Check in)
                            </div>
                            <div className='head '>
                              <div className='column'>
                                <h6>3 Hrs</h6>
                              </div>
                              <div className='column'>
                                <h6>6 Hrs</h6>
                              </div>
                              <div className='column'>
                                <h6>9 Hrs</h6>
                              </div>
                            </div>

                            <div className='body'>
                              <div className='column'>
                                <h6>3 Hrs</h6>
                                <div className='flex'>
                                  <select
                                    className='form-item fixed-width mr-2'
                                    value={slotTiming.threeHrs.checkIn}
                                    onChange={(e) =>
                                      setSlotTiming(prev => ({
                                        ...prev,
                                        threeHrs: { ...prev.threeHrs, checkIn: e.target.value }
                                      }))
                                    }
                                  >
                                    {timeZone?.map((time, i) => <option key={i}>{time}</option>)}
                                  </select>
                                  <select
                                    className='form-item fixed-width mr-2'
                                    value={slotTiming.threeHrs.checkOut}
                                    onChange={(e) =>
                                      setSlotTiming(prev => ({
                                        ...prev,
                                        threeHrs: { ...prev.threeHrs, checkOut: e.target.value }
                                      }))
                                    }
                                  >
                                    {timeZone?.map((time, i) => <option key={i}>{time}</option>)}
                                  </select>
                                </div>
                              </div>
                              <div className='column'>
                                <h6>3 Hrs</h6>
                                <div className='flex'>
                                  <select
                                    className='form-item fixed-width mr-2'
                                    value={slotTiming.sixHrs.checkIn}
                                    onChange={(e) =>
                                      setSlotTiming(prev => ({
                                        ...prev,
                                        sixHrs: { ...prev.sixHrs, checkIn: e.target.value }
                                      }))
                                    }
                                  >
                                    {timeZone?.map((time, i) => <option key={i}>{time}</option>)}
                                  </select>
                                  <select
                                    className='form-item fixed-width mr-2'
                                    value={slotTiming.sixHrs.checkOut}
                                    onChange={(e) =>
                                      setSlotTiming(prev => ({
                                        ...prev,
                                        sixHrs: { ...prev.sixHrs, checkOut: e.target.value }
                                      }))
                                    }
                                  >
                                    {timeZone?.map((time, i) => <option key={i}>{time}</option>)}
                                  </select>
                                </div>
                              </div>
                              <div className='column'>
                                <h6>3 Hrs</h6>
                                <div className='flex'>
                                  <select
                                    className='form-item fixed-width mr-2'
                                    value={slotTiming.nineHrs.checkIn}
                                    onChange={(e) =>
                                      setSlotTiming(prev => ({
                                        ...prev,
                                        nineHrs: { ...prev.nineHrs, checkIn: e.target.value }
                                      }))
                                    }
                                  >
                                    {timeZone?.map((time, i) => <option key={i}>{time}</option>)}
                                  </select>
                                  <select
                                    className='form-item fixed-width mr-2'
                                    value={slotTiming.nineHrs.checkOut}
                                    onChange={(e) =>
                                      setSlotTiming(prev => ({
                                        ...prev,
                                        nineHrs: { ...prev.nineHrs, checkOut: e.target.value }
                                      }))
                                    }
                                  >
                                    {timeZone?.map((time, i) => <option key={i}>{time}</option>)}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : ''
                      }
                    </div>

                  </div>
                </>
              )
            }
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-dark btn-md" variant="" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleBulkUpdate}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>

  )
}

export default ModalBulkUpdate
